const entries = [
  {
    cardImg:
      "https://img.rarible.com/prod/image/upload/t_image_preview/prod-itemImages/0xb66a603f4cfe17e3d27b87a8bfcad319856518b8:73637756889119870057734389589550337984663371938582731959958736796176219111434/5aa57630",
    eventType: "listings",

    info: {
      description: "SolFennex #10",
      prefixInfo: "15 editions listed by",
      suffixInfo: "for 0.05 ETH each",
      user: {
        avatar:
          "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xa2cd7e4fc26d95035c6fce0aba6af7a985668b06/avatar/QmYvHJfXte7okKW21qEDENFsE15ANr3GQSKmg6WqaCaFRK",
        name: "SolFennex",
        isVerified: false,
      },
    },
    date: "10.02.2020",
  },
  {
    cardImg:
      "https://img.rarible.com/prod/image/upload/t_image_preview/prod-itemImages/0xb66a603f4cfe17e3d27b87a8bfcad319856518b8:73637756889119870057734389589550337984663371938582731959958736796176219111434/5aa57630",
    eventType: "likes",

    info: {
      description: "DOUBLE CLIQUEZ POUR MODIFIER  double click to edit",
      prefixInfo: "liked by",
      suffixInfo: "",
      user: {
        avatar:
          "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0xa2cd7e4fc26d95035c6fce0aba6af7a985668b06/avatar/QmYvHJfXte7okKW21qEDENFsE15ANr3GQSKmg6WqaCaFRK",
        name: "SolFennex",
        isVerified: false,
      },
    },
    date: "10.02.2020",
  },
  {
    cardImg:
      "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0x7e7fd9b6b19513892249e7ee373e49f19643ec1c/avatar/Qmako6BHdTjV21jxtgJtWzTmiKKenDEPYeJgPvhvbE71jS",
    eventType: "followings",

    info: {
      description: "rofan",
      prefixInfo: "started following",
      suffixInfo: "",
      user: {
        avatar:
          "https://img.rarible.com/prod/image/upload/t_avatar_big/prod-users/0x8339deaf0f38528eb166e773c6b172a3200b71c7/avatar/QmZzKDQYBNhJGFXjmk7nKeqNhH7NCi4E6SX9TrzuAr7AYX",
        name: "Sweet Heart Ranch & Rescue",
        isVerified: true,
      },
    },
    date: "10.02.2020",
  },
  {
    cardImg:
      "https://img.rarible.com/prod/image/upload/t_image_preview/prod-itemImages/POLYGON-0x88883145049dec03c00cb7708cbc938058802520:1/bbf82914",
    eventType: "listings",

    info: {
      description: "Cool Box",
      prefixInfo: "1 edition minted by",
      suffixInfo: "",
      user: {
        avatar:
          "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgODAgODAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSIgaWQ9IjcwMzQxMjkyOTMwNyI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9InJnYigyNTUsIDAsIDkzKSIgb2Zmc2V0PSIwJSI+PC9zdG9wPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSJyZ2IoOTQsIDI1NSwgMCkiIG9mZnNldD0iMTAwJSI+PC9zdG9wPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPGcgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiBmaWxsPSJ1cmwoIzcwMzQxMjkyOTMwNykiIHg9IjAiIHk9IjAiIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCI+PC9yZWN0PgogIDwvZz4KPC9zdmc+",
        name: "0xa9b5190ed...8b31",
        isVerified: false,
      },
    },
    date: "10.02.2020",
  },
  {
    cardImg:
      "https://img.rarible.com/prod/image/upload/t_gif_thumb_preview/prod-itemImages/POLYGON-0xd769705e0f6265f12c13ce85aeb7a1218d655cfd:3/995f259e",
    eventType: "burns",

    info: {
      description: "Luck Rune",
      prefixInfo: "1 edition minted by",
      suffixInfo: "",
      user: {
        avatar:
          "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgODAgODAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSIgaWQ9IjcwMzQxMjkyOTMwNyI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9InJnYigyNTUsIDAsIDkzKSIgb2Zmc2V0PSIwJSI+PC9zdG9wPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSJyZ2IoOTQsIDI1NSwgMCkiIG9mZnNldD0iMTAwJSI+PC9zdG9wPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPGcgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiBmaWxsPSJ1cmwoIzcwMzQxMjkyOTMwNykiIHg9IjAiIHk9IjAiIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCI+PC9yZWN0PgogIDwvZz4KPC9zdmc+",
        name: "0xa9b5190ed...8b31",
        isVerified: false,
      },
    },
    date: "10.02.2020",
  },
];

export default entries;
